import { createBrowserRouter } from 'react-router-dom'
import { Container } from 'reactstrap'

// Elements
import Root from '../pages/Root/Root'
import VyuScan from '../VyuScanSDK/VyuScanV2'
import InvalidCodeError from '../pages/Error/InvalidCodeError'
import VyuScanAuto from '../VyuScanAutoSDK/VyuScanAuto'
import VyuVideo from '../VideoSDK/VyuVideo/VyuVideo'



const router = createBrowserRouter([
  {
    path: '',
    element: <Root />,
    errorElement: (
      <Container className='app-background'>
        <div className='app-container'>
          <h3 className='text-center t-100px '>404 Page not found!</h3>
        </div>
      </Container>
    ),
    children: [
      // {
      //   path: '/',
      //   element: <Homescreen />,
      // },
      // {
      //   path: 'scan/product/:productId',
      //   element: <VyuScan />,
      // },
      {
        path: 'scan/product/:productId',
        element: <VyuScanAuto />,
      },
      {
        path: 'video/product',
        element: <VyuVideo />,
      },
      {
         path: 'error/invalid',
        element: <InvalidCodeError />,
      }
    ],
  },
])

export default router